import { PropsWithChildren, ReactNode } from 'react';
import { useFeatureFlag } from '../../../misc';
import { Flex, Heading, Image, Paragraph } from '../../atoms';
import { Message } from '../message/message';

export function PageWrapperTemplate({
  backButton,
  imgSrc,
  readMoreButton,
  headerTitle,
  children,
  headerSubtitle
}: PropsWithChildren<{
  backButton?: ReactNode;
  imgSrc?: string | null;
  readMoreButton?: ReactNode;
  headerTitle: string;
  headerSubtitle?: string | null;
}>): JSX.Element {
  const hideReadMoreButtonFlag = !!useFeatureFlag(
    'hideReadMoreButtonBudgetAndBenefits'
  );

  return (
    <Flex flexDir="column" h="100%">
      <Flex
        p="space_unit.x4"
        alignItems="flex-start"
        flexDir="column"
        backgroundColor="palette_blue.0"
      >
        {backButton && backButton}

        <Flex>
          {imgSrc && <Image h="113px" w="auto" src={imgSrc} />}

          <Flex
            justifyContent="space-between"
            ml="space_unit.x4"
            flexDir="column"
            gap={2}
          >
            <Flex flexDir="column" gap={2}>
              <Heading as="h1" variant="h3">
                {headerTitle}
              </Heading>
              {headerSubtitle && (
                <Paragraph size="sm">
                  <Message
                    text={headerSubtitle}
                    fallback={headerSubtitle ?? ''}
                  />
                </Paragraph>
              )}
            </Flex>

            {!hideReadMoreButtonFlag && readMoreButton}
          </Flex>
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
}
